import { render, staticRenderFns } from "./education.vue?vue&type=template&id=50f7622e"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"
import style0 from "./education.vue?vue&type=style&index=0&id=50f7622e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports